<mat-form-field class="vzc-verification-code__full-field" floatLabel="always" appearance="outline" color="accent">
  <mat-label i18n="@@S_ACCOUNT_ACTIVATION_VERIFICATION_CODE_LABEL" id="aa-verification-code-label" for="aa-verification-code">
    Verification code
  </mat-label>
  <input
    matInput
    [formControl]="verificationCode"
    id="aa-verification-code"
    name="aa-verification-code"
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    maxlength="6"
    required="required"
    autocomplete="off"
    i18n-placeholder="@@S_ACCOUNT_ACTIVATION_INPUT_VERIFICATION_CODE_PLACEHOLDER"
    placeholder="Enter verification code"
    aria-labelledby="aa-verification-code-label"
  />

  <mat-error *ngIf="verificationCode.invalid" i18n="@@V_ACCOUNT_ACTIVATION_INPUT_VERIFICATION_CODE_ERROR">
    The code you entered is incorrect. Try again.
  </mat-error>
</mat-form-field>
